module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-form-search-skus"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "name": "sku",
      "placeholder": "O que você precisa alugar?",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSku(false)
      }, _vm.doSearch, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-vertical-keys", undefined, $event.key, undefined)) { return null; }
        $event.preventDefault();
        return _vm.navigate.apply(null, arguments)
      }],
      "blur": function($event) {
        return _vm.hide()
      },
      "focus": function($event) {
        return _vm.show()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.visible && _vm.skus.length > 0 || _vm.loading) ? _c('table', {
    staticClass: "table table-condensed table-bordered table-hover"
  }, [_c('tbody', [(_vm.loading) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('loading')], 1)]) : _vm._l((_vm.skus), function(sku, k) {
    return _c('tr', {
      class: {
        'active': k == _vm.focus
      },
      on: {
        "click": function($event) {
          return _vm.setSku(k)
        }
      }
    }, [_c('td', [_c('img', {
      staticClass: "photo",
      attrs: {
        "src": sku.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sku-title"
    }, [_vm._v(_vm._s(sku.title))])])])
  })], 2)]) : (_vm.searched) ? _c('table', {
    staticClass: "table table-condensed table-bordered table-hover"
  }, [_vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-back"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "title title-form title-default"
  }, [_vm._v("Nenhum produto encontrado!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b7356d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormSearchSkus.vue
// module id = 311
// module chunks = 18